import { Directive, ElementRef, Renderer2, AfterViewInit, Input, HostListener, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appMatTableAdjustRowHeight]',
    standalone: false
})
export class MatTableAdjustRowHeightDirective implements AfterViewInit{
  @Input() RowCount: number=0; // Input property to set the row number
  @Input() MaxRowCount: number=0; // Input property to set the max row number// scrolltop value change
  @Input() IsScrollBottom: boolean = true;

  scrollHeight: number=0;
  private isScrolling: boolean = false;
  private scrollTimeout: any;
  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Initialize the ResizeObserver
    this.resizeObserver = new ResizeObserver(entries => {
      var hscrollHeight=(this.el.nativeElement.offsetHeight-this.el.nativeElement.clientHeight);
        if(hscrollHeight>0){
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            this.ResizeDiv();
          }, 500);
        }
      });
    // Start observing the element
    this.resizeObserver.observe(this.el.nativeElement);
  }
  
  private ResizeDiv() {
    const thElements = this.el.nativeElement.querySelectorAll('thead tr') as NodeListOf<HTMLElement>;
    const trElements = this.el.nativeElement.querySelectorAll('tbody tr') as NodeListOf<HTMLElement>;
    var thHeight:number=0;
    thElements.forEach(th=>{thHeight=thHeight+th.offsetHeight;});

    var trHeight:number=0;
    var rowcount:number=0;
   
    trElements.forEach(tr=>{
      if(rowcount<=this.RowCount){
        trHeight=trHeight+tr.offsetHeight;
        rowcount++;
      }
    });
    var hscrollHeight=(this.el.nativeElement.offsetHeight-this.el.nativeElement.clientHeight);
    var newHeightDiv=thHeight+trHeight+hscrollHeight;

    this.renderer.setStyle(this.el.nativeElement, 'height', `${newHeightDiv}px`);
    if(rowcount<=this.RowCount){
      this.renderer.removeClass(this.el.nativeElement, 'show-scrollbar');
      this.renderer.addClass(this.el.nativeElement, 'hide-vertical-scrollbar');
    }
    else{
      this.renderer.removeClass(this.el.nativeElement, 'hide-vertical-scrollbar');
      this.renderer.addClass(this.el.nativeElement, 'show-scrollbar');
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['RowCount'] || changes['MaxRowCount']) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.ResizeDiv();
        if (changes['MaxRowCount']) {
          try {
            if(this.IsScrollBottom){
              this.el.nativeElement.scrollTop = this.el.nativeElement.scrollHeight;
            }
          } catch (err) {
            console.error(err);
          }
        }
        if (changes['RowCount']) {
          this.el.nativeElement.scrollTop =0;
        }
      }, 100);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
      this.ResizeDiv();
    }, 500);
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    // Check if the element has a vertical scrollbar
    if (target.scrollHeight > target.clientHeight) {
    // Set a flag to indicate that scrolling is happening
      this.isScrolling = true;
      // Clear any existing timeout
      clearTimeout(this.scrollTimeout);
      // Set a timeout to check if scrolling has stopped after 500 milliseconds
      this.scrollTimeout = setTimeout(() => {
        if (this.isScrolling) {
          this.isScrolling = false;
            const trElements: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('tbody tr');
            var trHeight = 0;
            if(trElements.length!=0){
              trHeight = trElements[0].offsetHeight;
            }
            //var norowscroll=Math.floor((target.scrollTop)/trHeight);
            //target.scrollTop=norowscroll*trHeight+1;
            // Calculate nearest row position
            const norowscroll = Math.round(target.scrollTop / trHeight);
            const newScrollTop = norowscroll * trHeight;
            // Adjust only if necessary
            if (target.scrollTop !== newScrollTop) {
              target.scrollTop = newScrollTop;
            }
        }
      }, 500); // Adjust the timeout duration as needed
    }
  }

}
